import { render, staticRenderFns } from "./FilterCards.vue?vue&type=template&id=535f4986&"
import script from "./FilterCards.vue?vue&type=script&lang=js&"
export * from "./FilterCards.vue?vue&type=script&lang=js&"
import style0 from "./FilterCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports